import api from '@/lib/api';
import type { CategoryChangeEligibility } from '@/types/tournament.model';

/** Lists, per player of a finished tournament, whether their category can still be changed. */
export const getCategoryChangeEligibility = async (
  tournamentId: string,
): Promise<CategoryChangeEligibility[]> => {
  const response = await api.get(
    `/tournaments/${tournamentId}/category-changes/eligibility`,
  );
  return response.data;
};

/** Moves a player of a finished tournament to another category. */
export const changePlayerCategory = async (
  tournamentId: string,
  playerEmail: string,
  categoryId: number,
): Promise<void> => {
  await api.post(`/tournaments/${tournamentId}/category-changes`, {
    playerEmail,
    categoryId,
  });
};
